import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import CheckpointApp from './CheckpointApp';
import { useAuthStore } from './stores/authStore';
import './index.css';

// Configuração do React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutos
    },
  },
});

// Função para inicializar a aplicação
function initApp() {
  // Aguarda o DOM estar completamente carregado
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initApp);
    return;
  }

  // Obtém configuração do WordPress
  const appElement = document.getElementById('haklai-app');
  const checkpointElement = document.getElementById('haklai-checkpoint');
  
  const targetElement = appElement || checkpointElement;
  
  if (!targetElement) {
    console.error('Haklai: Elemento #haklai-app ou #haklai-checkpoint não encontrado no DOM');
    return;
  }

  const isExternalCheckpoint = !!checkpointElement;
  const apiUrl = targetElement.dataset?.apiUrl || window.location.origin + '/wp-json/haklai/v1/';
  const pluginUrl = targetElement.dataset?.pluginUrl || '';

  // Define a URL da API GLOBALMENTE o mais cedo possível
  window.HAKLAI_API_URL = apiUrl;

  // Remove a mensagem de carregamento
  const loadingElement = targetElement.querySelector('.haklai-loading');
  if (loadingElement) {
    loadingElement.remove();
  }

  // Cria root element
  let rootElement = document.getElementById('haklai-react-root');
  if (!rootElement) {
    rootElement = document.createElement('div');
    rootElement.id = 'haklai-react-root';
    targetElement.appendChild(rootElement);
  }

  // Inicializa autenticação do localStorage
  const { initializeAuth } = useAuthStore.getState();
  initializeAuth();

  // Renderiza a aplicação React
  try {
    ReactDOM.createRoot(rootElement).render(
      <React.StrictMode>
        <QueryClientProvider client={queryClient}>
          {isExternalCheckpoint ? (
            <CheckpointApp apiUrl={apiUrl} pluginUrl={pluginUrl} />
          ) : (
            <App apiUrl={apiUrl} pluginUrl={pluginUrl} />
          )}
        </QueryClientProvider>
      </React.StrictMode>
    );
  } catch (error) {
    console.error('Haklai: Erro ao renderizar aplicação React:', error);
    targetElement.innerHTML = '<div style="padding: 20px; color: red;">Erro ao carregar a aplicação. Verifique o console para mais detalhes.</div>';
  }
}

// Inicializa a aplicação
initApp();

